import React from "react";

export default function GlobalLoader() {
  return (
    <>
      <style>
        {`
          .loader-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }

          .loader {
            width: 50px;
            aspect-ratio: 1;
            border-radius: 50%;
            background: 
              radial-gradient(farthest-side, #303e80 99%, #0000) top/8px 8px no-repeat,
              conic-gradient(#0000 30%, #303e80);
            -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
            animation: spin 1s infinite linear;
            
          }

          @keyframes spin { 
            100% { transform: rotate(1turn); }
          }
        `}
      </style>

      <div className="loader-overlay">
        <div className="loader"></div>
        <p
          style={{
            marginLeft: 15,
            color: "#ffffff",
            fontSize: "18px",
            fontFamily: "serif",
            fontWeight: 400,
          }}
        >
          Please wait
        </p>
      </div>
    </>
  );
}
